import { DeviceMode } from '../common/enums'

export interface DeviceConfig3Message {
  devicePin: string
  deviceAppMode: DeviceMode
}

export function decodeDeviceConfig3(data: Uint8Array): DeviceConfig3Message {
  const value = (data[0] << 12) | (data[1] << 4) | ((data[2] >> 4) & 0x0f)
  const devicePin = String(value).padStart(6, '0')
  const deviceAppMode =
    {
      0: DeviceMode.Standard,
      1: DeviceMode.WeatherStation,
      2: DeviceMode.WaterQuality,
      3: DeviceMode.DirtTracker,
    }[data[2] & 0x0f] || DeviceMode.Unknown

  if (deviceAppMode === DeviceMode.Unknown) {
    console.log(`Unknown "Device Mode": ${data[2] & 0x0f}`)
  }

  return {
    devicePin,
    deviceAppMode,
  }
}
